import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  IPutServiceReferenceIntAction,
  IPutServiceReferenceIntSuccessAction,
  IPutServiceReferenceIntErrorAction,
  IPutServiceReferenceIntResetAction,
  IPutServiceReferenceServiceIdSuccesActionInt,
} from '../actions/put-service-reference-int'
import {IOrderTrackerState} from '../state'
import {initialState} from '../state/initial-state'

export type PutServiceReferenceIntAction =
  | IPutServiceReferenceIntAction
  | IPutServiceReferenceIntSuccessAction
  | IPutServiceReferenceIntErrorAction
  | IPutServiceReferenceIntResetAction

const init = (state: IOrderTrackerState, action: PutServiceReferenceIntAction) => ({
  ...state,
  putServiceReferenceInt: {
    ...initialState.putServiceReferenceInt,
    status: action.status,
  },
})
const success = (state: IOrderTrackerState, action: PutServiceReferenceIntAction) => {
  return {
    ...state,
    putServiceReferenceInt: {
      ...initialState.putServiceReferenceInt,
      status: action.status,
    },
  }
}
const failure = (state: IOrderTrackerState, action: PutServiceReferenceIntAction) => ({
  ...state,
  putServiceReferenceInt: {
    ...initialState.putServiceReferenceInt,
    status: action.status,
    error: (action as IPutServiceReferenceIntErrorAction).error,
  },
})

const reset = (state: IOrderTrackerState, action: PutServiceReferenceIntAction) => {
  return {
    ...state,
    putServiceReferenceInt: {
      ...initialState.putServiceReferenceInt,
      status: action.status,
    },
  }
}

export const putServiceReferenceIntReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
  reset,
)

export const putServiceReferenceServiceIdReducer = (
  state: IOrderTrackerState,
  action: IPutServiceReferenceServiceIdSuccesActionInt,
) => {
  return {
    ...state,
    serviceIdReferenceInt: action.serviceId,
  }
}
